import React from "react";
import LoginLink from "./LoginLink";
import { VariantProps } from ".";
import WhyWeDoThis from "./WhyWeDoThis";
import PlusShippingLevels from "../PlusShippingLevels";
import GoogleViewPrice from "../GoogleViewPrice";
const C = (props: VariantProps) => {
  const {
    showBelowMinimumAdvertisedPriceForLoggedInCustomers,
    hasWebPlusDiscountedShipping,
    allowWebPlusDiscountedShipping,
    isWebstaurantPlusEligible,
    price,
    minimumBuy,
    mustBuy,
    isGoogleView,
    user
  } = props;
  return <div className="map map-override mapC" data-sentry-component="C" data-sentry-source-file="C.tsx">
      {isGoogleView && <GoogleViewPrice price={price.price} minimumBuy={minimumBuy} mustBuy={mustBuy} />}
      <PlusShippingLevels hasWebPlusDiscountedShipping={hasWebPlusDiscountedShipping} allowWebPlusDiscountedShipping={allowWebPlusDiscountedShipping} isWebstaurantPlusEligible={isWebstaurantPlusEligible} user={user} data-sentry-element="PlusShippingLevels" data-sentry-source-file="C.tsx" />
      <label className="to-see-label">To see our price</label>
      <p className="to-see-price mb-2">
        {showBelowMinimumAdvertisedPriceForLoggedInCustomers ? <>
            Add to cart or <LoginLink>login.</LoginLink>
          </> : <>Add this item to your cart.</>}
        <em>(You can remove it at any time.)</em>
      </p>
      {!price.hideWhyDoWeDoThis && <WhyWeDoThis type="cart" />}
    </div>;
};
export default C;